module.exports = __webpack_public_path__ + "img/1-img0ne.5c505427.png";